import React from 'react'
import { SellerBadgeModal } from './style'

export default () =>
    <SellerBadgeModal>
        <h2>Parceiro <strong>Santander</strong></h2>
        <div>Parceiro Santander é o vendedor que oferece taxas e benefícios
        exclusivos para a compra do seu novo veículo e total segurança
        na negociação.</div>
        <strong>Procure sempre pelo selo na hora de buscar um anúncio!</strong>
    </SellerBadgeModal>
